import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isBrowser, debug } from '../utilities/misc';
// import Cookies from 'js-cookie';

const defaultContext = {};

const OsanoContext = createContext(defaultContext);

const OsanoProvider = ({ children }) => {
  // initializes and keeps track of Osano analytics prop of consent obj
  /* eslint-disable-next-line max-len */
  const [osanoContextValue, setOsanoContextValue] = useState(defaultContext);
  const [beenDisabled, setBeenDisabled] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      const currentConsent = window?.Osano?.cm.getConsent();
      if (currentConsent === undefined || Object.keys(currentConsent).length === 0) {
        setOsanoContextValue({ ...currentConsent,
          ANALYTICS: 'DENY',
          beenDisabled });
      } else {
        setOsanoContextValue({ ...currentConsent, beenDisabled });
      }
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // when consent is saved, the state will update
  useEffect(() => {
    if (isBrowser) {
      window?.Osano?.cm.addEventListener('osano-cm-consent-saved', (savedConsentObj) => {
        if (savedConsentObj.ANALYTICS === 'DENY') {
          setBeenDisabled(true);
        }
        setOsanoContextValue({ ...savedConsentObj, beenDisabled });
        return () => {
        /* eslint-disable-next-line max-len */
          window?.Osano?.cm.removeEventListener('osano-cm-consent-saved', debug('consent listener removed'));
        };
      });
    }
  });

  return (
    <OsanoContext.Provider
      value={osanoContextValue}
    >
      {children}
    </OsanoContext.Provider>
  );
};

OsanoProvider.propTypes = {
  children: PropTypes.node
};

export { OsanoProvider };

export default OsanoContext;
